import { Constants } from "../shared/constants"

export const relatedCourseData = [
    {
        img: Constants.customImages.RelatedCourseImg,
        name: "UI/UX Designing",
    },
    {
        img: Constants.customImages.RelComputer,
        name: "UI Development",
    },
    {
        img: Constants.customImages.RelBookPen,
        name: "UI Development",
    },
    {
        img: Constants.customImages.RelatedCourseImg,
        name: "UI/UX Designing",
    },
    {
        img: Constants.customImages.RelBookPen,
        name: "UI Development",
    },
    {
        img: Constants.customImages.RelBookPen,
        name: "UI Development",
    },


]